module.exports = __webpack_public_path__ + "assets/img/returnBtn-b2a6a014.png";